<template>
  <div style="background-color: #fafafa;">
    <van-nav-bar
      title="盘点列表"
      left-text="返回"
      left-arrow
      @click-left="onClickLeft"
      :z-index="998"
      fixed
    />
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <van-list
        v-model="loading"
        :finished="finished"
        @load="onLoad"
        finished-text="没有更多了"
      >
        <div
          v-for="data in list"
          class="card"
          :key="data.uuid"
          @click="openDetail(data.uuid,data.status)"
        >
          <table class="layout">
            <tr>
              <td colspan="2" class="content">
                <p>
                  <span>盘点时间：</span>
                  <span>{{ data.createTime || "无" }}</span>
                </p>
                <p>
                  <span>盘点人：</span>
                  <span>{{ data.creatorIdname || "无" }}</span>
                </p>
                <p>
                  <span>盘点仓库：</span>
                  <span>{{ data.warehouseIdname || "无" }}</span>
                </p>
                <p>
                  <span>盘点状态：</span>
                  <span>{{ data.statusname || "无" }}</span>
                </p>
              </td>
            </tr>
          </table>
        </div>
      </van-list>
    </van-pull-refresh>
    <div class="recordBox">
      <div
        style="display: flex;justify-content: space-between;align-items: center;"
      >
        <van-button
          style="height:30px;font-size: 14px;"
          type="info"
          size="large"
          @click="startStockTaking"
          >开始盘点</van-button
        >
      </div>
    </div>
    <van-action-sheet v-model="show" :actions="actions" @select="onSelect" cancel-text="取消" />
<!--    <van-popup v-model="show" closeable position="bottom" :style="{ height: '50%' }">-->
<!--    </van-popup>-->
  </div>
</template>

<script>
import {
  Tab,
  Tabs,
  Panel,
  Button,
  List,
  Search,
  Popup,
  PullRefresh,
  NavBar,
  Tag,
  Col,
  Row,
  Sidebar,
  SidebarItem,
  DatetimePicker,
  Field,
  DropdownMenu,
  DropdownItem,
  Icon, ActionSheet, Toast,
} from "vant";
import userInfo from "../../store/userInfo";
import stockTakingService from "../../service/stockTakingService";
// import moment from "moment";
import { formatDictionary } from "../../utils/dictionary";
import { API_URL } from "../../common/config";

export default {
  data: function() {
    return {
      list: [], //数据列表
      loading: false,
      finished: false, //数据加载完成
      pageIndex: 0, //第几页
      value: "", //搜索值
      refreshing: false, //是否刷新
      type: 2, //选项卡index
      show:false,
      actions:[]
    };
  },
  store: userInfo,
  components: {
    [Tab.name]: Tab,
    [Tag.name]: Tag,
    [NavBar.name]: NavBar,
    [Tabs.name]: Tabs,
    [Button.name]: Button,
    [PullRefresh.name]: PullRefresh,
    [Panel.name]: Panel,
    [List.name]: List,
    [Col.name]: Col,
    [Row.name]: Row,
    [Search.name]: Search,
    [Popup.name]: Popup,
    [Sidebar.name]: Sidebar,
    [SidebarItem.name]: SidebarItem,
    [DatetimePicker.name]: DatetimePicker,
    [Field.name]: Field,
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
    [Icon.name]: Icon,
    [ActionSheet .name]:ActionSheet
  },
  computed: {
    userId() {
      return this.$store.getters.getUserId;
    },
    avatarUrl() {
      return API_URL + "/oa/common/attachment/showImage?id=";
    },
  },
  created: async function() {},
  methods: {
    async onLoad() {
      this.pageIndex++;
      let resp = await stockTakingService.getStockTakingList(
        this.pageIndex,
        this.value
      );
      if (resp.data.Status == "1" && resp.data.Data.data.length > 0) {
        // resp.data.Data.data.forEach((item) => {
        //   item.createTime = moment(item.createTime).format("YYYY-MM-DD");
        // });
        formatDictionary(resp.data.Data.data, resp.data.Data.dictionary);
      }
      this.loading = false;
      this.refreshing = false;
      formatDictionary(resp.data.Data.data, resp.data.Data.dictionary);
      this.list = [...this.list, ...resp.data.Data.data];
      this.finished = resp.data.Data.total <= this.list.length;
      let r = await stockTakingService.getZLSelectDict("psi_warehouse");
      if (r.data.Status == "1" && r.data.Data) {
        this.actions = r.data.Data
      }
    },
    onRefresh() {
      this.finished = false;
      this.pageIndex = 0;
      this.list = [];
      this.onLoad();
    },
    openDetail(uuid,status) {
      this.$router.push({ path: "/electronicErp/stockTakingCategory/" + uuid + "/" + status });
    },

    onClickLeft() {
      window.open("/colseWebView");
    },
    async onSelect(item) {
      // 点击选项时默认不会关闭菜单，可以手动关闭
      this.show = false;
      // eslint-disable-next-line no-undef
      this.status = item.uuid;
      Toast.loading({
        duration:0,
        message: '生成盘点中',
        forbidClick: true,
      });
      let resp = await stockTakingService.insertStocktaking(
          this.status
      );
      if (resp.data.Status == "1" && resp.data.Data) {
        Toast.clear();
        await this.$router.push({path: "/electronicErp/stockTakingCategory/" + resp.data.Data + "/1"});
      }
    },
    startStockTaking() {
      this.show = true;
    },
  },
};
</script>

<style>
.dropdownItem > .van-dropdown-item > .van-popup {
  max-height: 100%;
  height: 100%;
}
.van-popup--right {
  width: 100%;
  height: 100%;
}
.van-nav-bar {
  z-index: 99999;
}
.van-icon {
  margin-right: 0.6rem;
  color: #4090fa;
}

.icon {
  margin-left: 1rem;
}
.recordBox {
  padding: 0.5rem 0;
  box-sizing: border-box;
  margin-top: 2rem;
  bottom: 0;
  position: fixed;
  width: 100%;
}
</style>
